import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { BehaviorSubject } from "rxjs";

import {
  lightCategoryColors,
  lightPillarColors,
  mediumCategoryColors,
  mediumPillarColors,
  PillarSlug,
  strongCategoryColors,
  strongPillarColors
} from "../../../../thematics/colors";
import { Thematic } from "../../../../thematics/models/thematic.model";
import { Tag } from "../../tags/tags.component";

@Component({
  selector: 'app-thematic-card',
  templateUrl: './thematic-card.component.html',
  styleUrls: [ './thematic-card.component.scss' ]
})
export class ThematicCardComponent implements OnInit, OnChanges {

  public tags$ = new BehaviorSubject<Tag[]>([]);

  colorMedium!: string;

  colorStrong!: string;

  colorLight!: string;

  hovered = false;


  @Input() thematic!: Thematic;

  @Input('available-dates') availableDates: Date[] = [];

  @Input() withoutTitle = false;

  @Input() big = false;

  @Input() tiny = false;

  @Input() isDetailsPage = false;

  ngOnInit() {
    // Use pillar colors if available, otherwise fallback to category colors
    const pillarName = this.thematic.pillar?.name as PillarSlug;
    const categorySlug = this.thematic.category?.slug;

    this.colorMedium = pillarName
      ? mediumPillarColors[pillarName]
      : (categorySlug ? mediumCategoryColors[categorySlug] : '');
    this.colorStrong = pillarName
      ? strongPillarColors[pillarName]
      : (categorySlug ? strongCategoryColors[categorySlug] : '');
    this.colorLight = pillarName
      ? lightPillarColors[pillarName]
      : (categorySlug ? lightCategoryColors[categorySlug] : '');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.thematic) {
      this.tags$.next(changes.thematic.currentValue.tags);
    }
  }

  onMouseOver(): void {
    this.hovered = true;
  }

  onMouseLeave(): void {
    this.hovered = false;
  }
}
